import * as fromdatosMPSActions from '../../../actions/Componentes/Modelos/datosMPS.actions';
import { datosModelo } from 'src/app/models/SicarMap/datosModelo.model';


export interface MPState {
    visible: boolean;
    confModelo: datosModelo;
}

const initialStateDMPS: MPState = {
    visible: false,
    confModelo : null
};

export function mPSReducer(state = initialStateDMPS, action: fromdatosMPSActions.MPSActions): MPState {
    switch (action.type) {
        case fromdatosMPSActions.VISIBLE_PANELMPS:
            return {
                ...state,
                visible: true,
                confModelo: action.ConfModelo
            };
        case fromdatosMPSActions.HIDDEN_PANELMPS:
            return {
                ...state,
                visible: false,
                confModelo: null
            };
      default: {
        return state;
      }
    }
}
